import * as React from "react";
import type { SVGProps } from "react";
const SvgAiSparkSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.43 8.62 1.422.54a4 4 0 0 1 2.318 2.32l.54 1.42a.667.667 0 0 0 1.247 0l.54-1.42a4 4 0 0 1 2.318-2.32l1.422-.54a.667.667 0 0 0 0-1.246l-1.422-.54a4 4 0 0 1-2.318-2.318l-.54-1.422a.667.667 0 0 0-1.247 0l-.54 1.422a4 4 0 0 1-2.318 2.318l-1.422.54a.667.667 0 0 0 0 1.247"
      clipRule="evenodd"
    />
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 14.003v-2.667M2.667 12.67h2.666M3.333 4.667V2M2 3.333h2.667"
    />
  </svg>
);
export default SvgAiSparkSmall;
